/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_TitleInputs */



/**
* | output |
* | --- |
* | "Merge Speakers" |
*
* @param {Speaker_Manager_Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_title = /** @type {((inputs?: Speaker_Manager_Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen von Sprechern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить докладчиков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを結合する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं को मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unir alto-falantes")
	return /** @type {LocalizedString} */ ("Merge Speakers")
});